import Axios from "axios";

var config = {
  headers: { Authorization: "Bearer " + localStorage.getItem("access_token") }
};

export default {
  changeSetting(device, settingKey, newValue) {
    return Axios.post(
      "/changeSetting",
      {
        deviceID: device,
        setting: settingKey,
        value: newValue
      },
      {
        headers: { Authorization: "Bearer " + localStorage.getItem("access_token") }
      }
    );
  }
};



// WEBPACK FOOTER //
// ./src/api/settings.service.js